import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import investigatorImage from '../../../Assets/ResearchLabs/GSERL/Director/waheed.png';

const { Link, Text, Title } = Typography;

const GSerlHead = () => (
  <section className="principal-investigator-section">
    <div className="investigator-content">
      <Title level={2} className="investigator-title">
        Principal Investigator/Lab Director
      </Title>
      <Divider className="ncgsa-divider" />

      <img className="investigator-photo" src={investigatorImage} alt="Dr. Abdul Waheed" />
      <Text strong className="investigator-name">Dr. Abdul Waheed</Text>
      <Text className="investigator-affiliation">IST, Islamabad</Text>
      <Link className="investigator-contact" href="mailto:waheed901@yahoo.com">
        waheed901@yahoo.com
      </Link>
      <Link className="investigator-contact" href="tel:+92519075467">
        Phone: 051-907-5467
      </Link>
    </div>
  </section>
);

export default GSerlHead;
